/** Construction des GeoJSON affichés : tracé coloré par vitesse, gares, fantômes. */
import type { FeatureCollection, LineString, Point } from "geojson";
import type { RouteData } from "../model/route";
import type { RunResult } from "../model/run";

/** Le tracé découpé en tronçons de vitesse homogène (classes de 10 km/h). */
export function routeFeatures(route: RouteData, result: RunResult | null): FeatureCollection<LineString> {
  const feats: FeatureCollection<LineString>["features"] = [];
  const n = route.coords.length;
  const cls = (x: number) => (result ? Math.min(110, Math.round((result.v[x] * 3.6) / 10) * 10) : 110);
  let start = 0;
  let cur = cls(0);
  for (let x = 1; x <= n; x++) {
    const c = x < n ? cls(x) : -1;
    if (c !== cur) {
      // on prolonge d'un point pour éviter les trous entre tronçons
      const end = Math.min(x, n - 1);
      feats.push({
        type: "Feature",
        properties: { v: cur },
        geometry: { type: "LineString", coordinates: route.coords.slice(start, end + 1) },
      });
      start = end;
      cur = c;
    }
  }
  return { type: "FeatureCollection", features: feats };
}

export function stopFeatures(
  route: RouteData,
  stops: number[],
  selected: number | null,
  name: (idx: number) => string,
): FeatureCollection<Point> {
  return {
    type: "FeatureCollection",
    features: stops.map((idx) => ({
      type: "Feature",
      id: idx,
      properties: { idx, name: name(idx), selected: idx === selected },
      geometry: { type: "Point", coordinates: route.coords[idx] },
    })),
  };
}

export function ghostFeatures(route: RouteData, stops: number[]): FeatureCollection<Point> {
  const set = new Set(stops);
  return {
    type: "FeatureCollection",
    features: route.reference_stations
      .filter((s) => !set.has(s.idx))
      .map((s) => ({
        type: "Feature",
        id: s.idx,
        properties: { idx: s.idx, name: s.name },
        geometry: { type: "Point", coordinates: route.coords[s.idx] },
      })),
  };
}
